import React, { useContext, useState } from "react";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import routes from "../../routes/route";
import AuthContext from "../../../Auth/AuthContext";
import "./SidebarPremium.css";

const Sidebar = ({ isSidebarOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { apiProvider } = useContext(AuthContext);

  return (
    <nav className={`sidebar-premium ${isSidebarOpen ? "sidebar-icon-only open" : ""}`}>
      {/* Search Bar Section */}
      {/* <div className="sidebar-search-container">
        <div className="sidebar-search-wrapper">
          <i
            className="ri-search-line"
            onClick={() => navigate(routes.games.topGames)}
            style={{ cursor: "pointer" }}
          ></i>
          <input type="text" placeholder="Search games..." />
        </div>
      </div> */}

      {/* Wallet / Token Section */}
      {/* <div className="token-card">
        <div className="token-info-top">
          <div className="token-icon">N$</div>
          <span className="token-name">Namibian Dollar (NAD)</span>
        </div>

        <div className="token-value-row">
          <span className="token-amount">N$18.75</span>
          <span className="token-change">+1.20%</span>
        </div>
        <div className="token-actions">
          <button className="btn-token-action">Convert</button>
          <button className="btn-token-action">Dashboard</button>
        </div>
      </div> */}

      <ul className="sidebar-nav-list">
        {/* RECOMMENDED SECTION */}
        {/* <div className="nav-category-label">Recommended</div> */}

        <li className="sidebar-nav-item">
          <NavLink
            to={routes.home}
            className={({ isActive }) => `sidebar-nav-link ${isActive ? "active" : ""}`}
          >
            <i className="ri-home-4-fill"></i>
            <span>Home</span>
          </NavLink>
        </li>

        <li className="sidebar-nav-item">
          <NavLink
            to={routes.games.topGames}
            className={({ isActive }) => `sidebar-nav-link ${isActive ? "active" : ""}`}
          >
            <i className="ri-dice-fill"></i>
            <span>All Games</span>
          </NavLink>
        </li>

        <li className="sidebar-nav-item">
          <NavLink
            to="/filtered-games?type=card"
            className={() =>
              `sidebar-nav-link ${location.pathname === routes.games.filteredGames &&
                location.search === "?type=card"
                ? "active"
                : ""
              }`
            }
          >
            <i className="fi fi-rr-playing-cards"></i>
            <span>Live Casino</span>
          </NavLink>
        </li>

        <li className="sidebar-nav-item">
          <NavLink
            to="/filtered-games?type=crash"
            className={() =>
              `sidebar-nav-link ${location.pathname === routes.games.filteredGames &&
                location.search === "?type=crash"
                ? "active"
                : ""
              }`
            }
          >
            <i className="ri-fire-fill"></i>
            <span>Crash Games</span>
            <span className="badge-new">Hot</span>
          </NavLink>
        </li>

        <li className="sidebar-nav-item">
          <NavLink
            to={routes.games.providers}
            className={({ isActive }) => `sidebar-nav-link ${isActive ? "active" : ""}`}
          >
            <i className="ri-building-4-fill"></i>
            <span>Providers</span>
          </NavLink>
        </li>

        {/* BONUS & INFO */}
        <div className="nav-category-label">Bonus & Help</div>

        <li className="sidebar-nav-item">
          <NavLink
            to={routes.games.bonus + "?tab=referral"}
            className={({ isActive }) => `sidebar-nav-link ${isActive ? "active" : ""}`}
          >
            <i className="ri-gift-fill"></i>
            <span>Referral</span>
          </NavLink>
        </li>

        <li className="sidebar-nav-item">
          <NavLink
            to={routes.pages.responsiblegame}
            className={({ isActive }) => `sidebar-nav-link ${isActive ? "active" : ""}`}
          >
            <i className="ri-shield-user-fill"></i>
            <span>Responsible Gaming</span>
          </NavLink>
        </li>

        <li className="sidebar-nav-item">
          <NavLink
            to={routes.pages.howToPlay}
            className={({ isActive }) => `sidebar-nav-link ${isActive ? "active" : ""}`}
          >
            <i className="ri-question-fill"></i>
            <span>How to Play</span>
          </NavLink>
        </li>

        {/* SPORTS SECTION */}
        {apiProvider?.includes("turbosportsbook") && (
          <>
            <div className="nav-category-label">Sports</div>
            <li className="sidebar-nav-item">
              <NavLink
                to={`${routes.pages.sportsbook.turboSports}?setIframePath=/football`}
                className={({ isActive }) => `sidebar-nav-link ${isActive ? "active" : ""}`}
                onClick={(e) => {
                  e.preventDefault();
                  sessionStorage.setItem("launchTurboSports", "true");
                  navigate(`${routes.pages.sportsbook.turboSports}?setIframePath=/football`, {
                    state: { fromSidebar: true },
                  });
                }}
              >
                <i className="ri-football-fill"></i>
                <span className="d-flex align-items-center gap-2">
                  Soccer <div className="badge-new" style={{ backgroundColor: "#ef4444" }}>LIVE</div>
                </span>
              </NavLink>
            </li>
          </>
        )}

        <div className="nav-category-label">Legal</div>
        <li className="sidebar-nav-item">
          <NavLink
            to={routes.pages.terms}
            className={({ isActive }) => `sidebar-nav-link ${isActive ? "active" : ""}`}
          >
            <i className="ri-file-list-3-fill"></i>
            <span>Terms and Conditions</span>
          </NavLink>
        </li>
        <li className="sidebar-nav-item">
          <NavLink
            to={routes.pages.privacyPolicy}
            className={({ isActive }) => `sidebar-nav-link ${isActive ? "active" : ""}`}
          >
            <i className="ri-lock-fill"></i>
            <span>Privacy and policy</span>
          </NavLink>
        </li>
      </ul>
    </nav>
  );
};

export default Sidebar;
